import { ManagementServiceConstants } from "../models/managements/managements.agent.model";

export const AGENT_MANAGEMENT_TYPE_QUERY_PARAM = "type";

export enum AGENT_MANAGEMENT_TYPES {
  MODEL_200 = "model-200",
  DEFERRED_PAYMENT = "deferred-payment",
  GREEN_ENERGY_REQUEST = "green-energy-request",
  AUTO_CONSUMPTION = "auto-consumption",
  TOGGLE_PAPER_BILL = "toggle-paper-bill",
  OFFSET_INVOICE_CREDIT = "offset-invoice-credit",
  CUSTOMER_DEBT_INFO = "customer-debt-info",
  ATR_REJECTION = "atr-rejection",
  PAYMENT_PROOF = "payment-proof",
  TACIT_RENEWAL_INTERRUPTION = "tacit-renewal-interruption",
  REPLACEMENT = "replacement",
  SUB_AGENT_CHANGE = "sub-agent-change",
  PRODUCT_CHANGE_REQUEST = "product-change-request",
  CHANGE_METER_EQUIPMENT = "change-meter-equipment",
  INVOICE_REMITTANCE = "invoice-remittance",
  CUPS_INFO_PENDING_DISTRIBUTOR = "cups-info-pending-distributor",
  CUSTOMER_INVOICE_COMPONENTS_DETAILS = "customer-invoice-components-details",
  EARLY_TERMINATION_PENALTY = "early-termination-penalty",
}

export const AGENT_MANAGEMENT_SERVICE_CONSTANTS: ManagementServiceConstants = {
  "model-200": {
    titleKey: "Modelo 200",
    cupOptionsFilter: "all",
    isFileRequired: true,
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 159,
        managementText: "Model 200",
        userDestinationId: 3957,
      },
      GAS: {
        registerTypeId: 3,
        subTypeReclamationId: 165,
        managementText: "Model 200",
        userDestinationId: 3958,
      },
    },
  },
  "deferred-payment": {
    titleKey: "Fraccionamiento de pago",
    cupOptionsFilter: "all",
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 158,
        managementText: "Fraccionamiento de pago",
        userDestinationId: 3528,
      },
      GAS: {
        registerTypeId: 3,
        subTypeReclamationId: 164,
        managementText: "Fraccionamiento de pago",
        userDestinationId: 3529,
      },
    },
  },
  "green-energy-request": {
    titleKey: "Solicitud energía verde",
    cupOptionsFilter: "all",
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 231,
        managementText: "Solicitud Energía Verde",
        userDestinationId: 4647,
      },
      GAS: {
        registerTypeId: 3,
        subTypeReclamationId: 232,
        managementText: "Solicitud Energía Verde",
        userDestinationId: 4648,
      },
    },
  },
  "auto-consumption": {
    titleKey: "Autoconsumo",
    cupOptionsFilter: "luz",
    isFileRequired: true,
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 77,
        managementText: "Autoconsumo",
        userDestinationId: 3956,
      },
      GAS: {
        // Currently not used
        registerTypeId: 0,
        subTypeReclamationId: 0,
        managementText: "",
        userDestinationId: 0,
      },
    },
  },
  "toggle-paper-bill": {
    titleKey: "Habilitar / Deshabilitar factura en papel",
    cupOptionsFilter: "all",
    isFileRequired: true,
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 62,
        managementText: "Habilitar / Deshabilitar Factura en Papel",
        userDestinationId: 3956,
      },
      GAS: {
        registerTypeId: 3,
        subTypeReclamationId: 105,
        managementText: "Habilitar / Deshabilitar Factura en Papel",
        userDestinationId: 4668,
      },
    },
  },
  "offset-invoice-credit": {
    titleKey: "Compensación de facturas y abonos",
    cupOptionsFilter: "all",
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 160,
        managementText: "Compensación de facturas y abonos",
        userDestinationId: 3528,
      },
      GAS: {
        registerTypeId: 3,
        subTypeReclamationId: 166,
        managementText: "Compensación de facturas y abonos",
        userDestinationId: 3529,
      },
    },
  },
  "customer-debt-info": {
    titleKey: "Información deuda cliente",
    cupOptionsFilter: "all",
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 161,
        managementText: "Información deuda cliente",
        userDestinationId: 3528,
      },
      GAS: {
        registerTypeId: 3,
        subTypeReclamationId: 167,
        managementText: "Información deuda cliente",
        userDestinationId: 3529,
      },
    },
  },
  "atr-rejection": {
    titleKey: "Gestión rechazo ATR",
    cupOptionsFilter: "all",
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 163,
        managementText: "Gestión rechazo ATR",
        userDestinationId: 3956,
      },
      GAS: {
        registerTypeId: 3,
        subTypeReclamationId: 129,
        managementText: "Gestión rechazo ATR",
        userDestinationId: 3959,
      },
    },
  },
  "payment-proof": {
    titleKey: "Justificante de pago",
    cupOptionsFilter: "all",
    isFileRequired: true,
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 267,
        managementText: "Justificante de pago",
        userDestinationId: 3528,
      },
      GAS: {
        registerTypeId: 3,
        subTypeReclamationId: 268,
        managementText: "Justificante de pago",
        userDestinationId: 3529,
      },
    },
  },
  "tacit-renewal-interruption": {
    titleKey: "Interrupción renovación tácita",
    cupOptionsFilter: "all",
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 186,
        managementText: "Interrupción renovación tácita",
        userDestinationId: 4647,
      },
      GAS: {
        registerTypeId: 3,
        subTypeReclamationId: 174,
        managementText: "Interrupción renovación tácita",
        userDestinationId: 4648,
      },
    },
  },
  replacement: {
    titleKey: "Reposición",
    cupOptionsFilter: "all",
    isFileRequired: true,
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 209,
        managementText: "Reposición",
        userDestinationId: 3956,
      },
      GAS: {
        registerTypeId: 3,
        subTypeReclamationId: 135,
        managementText: "Reposición",
        userDestinationId: 3959,
      },
    },
  },
  "sub-agent-change": {
    titleKey: "Cambio de sub-agente",
    cupOptionsFilter: "all",
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 228,
        managementText: "Cambio de sub-agente",
        userDestinationId: 4647,
      },
      GAS: {
        registerTypeId: 3,
        subTypeReclamationId: 133,
        managementText: "Cambio de sub-agente",
        userDestinationId: 4648,
      },
    },
  },
  "product-change-request": {
    titleKey: "Solicitud de cambio de producto",
    cupOptionsFilter: "all",
    isFileRequired: true,
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 241,
        managementText: "Solicitud de cambio de producto",
        userDestinationId: 4649,
      },
      GAS: {
        registerTypeId: 3,
        subTypeReclamationId: 242,
        managementText: "Solicitud de cambio de producto",
        userDestinationId: 4650,
      },
    },
  },
  "change-meter-equipment": {
    titleKey: "Cambio de equipos de medida a clientes (alquiler vs propiedad)",
    cupOptionsFilter: "all",
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 223,
        managementText:
          "Cambio de equipos de medida a clientes (alquiler vs propiedad)",
        userDestinationId: 3956,
      },
      GAS: {
        registerTypeId: 3,
        subTypeReclamationId: 224,
        managementText:
          "Cambio de equipos de medida a clientes (alquiler vs propiedad)",
        userDestinationId: 3959,
      },
    },
  },
  "invoice-remittance": {
    titleKey: "Remesado de facturas",
    cupOptionsFilter: "all",
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 265,
        managementText: "Remesado de Facturas",
        userDestinationId: 3528,
      },
      GAS: {
        registerTypeId: 3,
        subTypeReclamationId: 262,
        managementText: "Remesado de Facturas",
        userDestinationId: 3529,
      },
    },
  },
  "cups-info-pending-distributor": {
    titleKey: "Información CUPS en estado pendiente distribuidora",
    cupOptionsFilter: "all",
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 233,
        managementText: "Información CUPS en estado: pendiente distribuidora",
        userDestinationId: 4647,
      },
      GAS: {
        registerTypeId: 3,
        subTypeReclamationId: 234,
        managementText: "Información CUPS en estado: pendiente distribuidora",
        userDestinationId: 4648,
      },
    },
  },
  "customer-invoice-components-details": {
    titleKey: "Detalle componentes de facturas a clientes",
    cupOptionsFilter: "luz",
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 221,
        managementText: "Detalle componentes de facturas a clientes",
        userDestinationId: 4647,
      },
      GAS: {
        // Currently not used
        registerTypeId: 0,
        subTypeReclamationId: 0,
        managementText: "",
        userDestinationId: 0,
      },
    },
  },
  "early-termination-penalty": {
    titleKey: "Penalización baja anticipada",
    cupOptionsFilter: "luz",
    servicePayloadData: {
      ELECTRICITY: {
        registerTypeId: 2,
        subTypeReclamationId: 215,
        managementText: "Penalización baja anticipada",
        userDestinationId: 1610,
      },
      GAS: {
        // Currently not used
        registerTypeId: 0,
        subTypeReclamationId: 0,
        managementText: "",
        userDestinationId: 0,
      },
    },
  },
};
